import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=3868bade&scoped=true"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&id=3868bade&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868bade",
  null
  
)

export default component.exports